import { render, staticRenderFns } from "./AttachmentDragAndDrop.vue?vue&type=template&id=45a3ba53&scoped=true&"
import script from "./AttachmentDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./AttachmentDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDragAndDrop.vue?vue&type=style&index=0&id=45a3ba53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3ba53",
  null
  
)

export default component.exports